import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 4C17 2.89543 16.1046 2 15 2H14V5H17V4Z" fill="#5D6688" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 6H14C13.4477 6 13 5.55228 13 5V2H5C3.89543 2 3 2.89543 3 4V16C3 17.1046 3.89543 18 5 18H12.126C12.0438 17.6804 12 17.3453 12 17C12 14.7909 13.7909 13 16 13C16.3453 13 16.6804 13.0438 17 13.126V6ZM7.5 12C7.22386 12 7 12.2239 7 12.5C7 12.7761 7.22386 13 7.5 13H12.5C12.7761 13 13 12.7761 13 12.5C13 12.2239 12.7761 12 12.5 12H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5Z"
      fill="#5D6688"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 17C19 18.6569 17.6569 20 16 20C14.3431 20 13 18.6569 13 17C13 15.3431 14.3431 14 16 14C17.6569 14 19 15.3431 19 17ZM16.8964 15.8964C17.0917 15.7012 17.4083 15.7012 17.6036 15.8964C17.7988 16.0917 17.7988 16.4083 17.6036 16.6036L15.75 18.4571L14.3964 17.1036C14.2012 16.9083 14.2012 16.5917 14.3964 16.3964C14.5917 16.2012 14.9083 16.2012 15.1036 16.3964L15.75 17.0429L16.8964 15.8964Z"
      fill="#5D6688"
    />
  </svg>
);
